import { useQuery } from "@tanstack/react-query";
import { fetchKicktipp } from "../../../api/fetchKicktipp";

export const useKicktippQuery = () =>
  useQuery({
    queryKey: ['kicktipp'],
    queryFn: () => fetchKicktipp(),
    // ponytail: refresh on a timer, decoupled from screen transitions. Raise if scores update slower.
    refetchInterval: 60_000,
  })